<button (click)="leftClick()" class="button"></button>
